'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var rmAll = require('./rm-all.js');
var last = require('it-last');
var configure = require('../lib/configure.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

const createRm = config => {
  const all = rmAll.createRmAll(config);
  return configure.configure(() => {
    async function rm(path, options = {}) {
      return last__default['default'](all([{
          path,
          ...options
        }], options));
    }
    return rm;
  })(config);
};

exports.createRm = createRm;
